import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import erpFetcher from "@/common/fetchErpnextServices";
var DEFAULT_PAGINATION_VALUES = {
  page: 1,
  limit: 7
};
export var api__getAvailableTimeSlot = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(request_id, inspection_site_type, inspection_location, area_id, daystamp) {
    var _res$data;
    var res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return erpFetcher().post("/inspection-appointment/reschedule-times-final", _objectSpread({
            request_id: request_id,
            inspection_site_type: inspection_site_type,
            inspection_location: inspection_location,
            area_id: area_id,
            daystamp: daystamp
          }, DEFAULT_PAGINATION_VALUES));
        case 1:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || []);
      }
    }, _callee);
  }));
  return function api__getAvailableTimeSlot(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
export var api__getAvailableDays = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(request_id, inspection_site_type, area_id, inspection_location, paginationParams) {
    var _res$data2, _res$data2$data;
    var res, arr;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return erpFetcher().post("/inspection-appointment/reschedule-days-final", _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            request_id: request_id,
            inspection_site_type: inspection_site_type
          }, area_id && {
            area_id: area_id
          }), inspection_location && {
            inspection_location: inspection_location
          }), DEFAULT_PAGINATION_VALUES), paginationParams));
        case 1:
          res = _context2.v;
          arr = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : _res$data2$data.available_days;
          return _context2.a(2, arr || []);
      }
    }, _callee2);
  }));
  return function api__getAvailableDays(_x6, _x7, _x8, _x9, _x0) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__createAppointmentFinal = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref3) {
    var request_id, city_id, inspection_site_type, inspection_location, area_id, location, daystamp, from_timestamp, to_timestamp, res;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          request_id = _ref3.request_id, city_id = _ref3.city_id, inspection_site_type = _ref3.inspection_site_type, inspection_location = _ref3.inspection_location, area_id = _ref3.area_id, location = _ref3.location, daystamp = _ref3.daystamp, from_timestamp = _ref3.from_timestamp, to_timestamp = _ref3.to_timestamp;
          _context3.n = 1;
          return erpFetcher().post("/inspection-appointment/reschedule-final", {
            request_id: request_id,
            city_id: city_id,
            inspection_site_type: inspection_site_type,
            area_id: area_id,
            location: location,
            daystamp: daystamp,
            from_timestamp: from_timestamp,
            to_timestamp: to_timestamp,
            inspection_location: inspection_location
          });
        case 1:
          res = _context3.v;
          return _context3.a(2, (res === null || res === void 0 ? void 0 : res.data) || {});
      }
    }, _callee3);
  }));
  return function api__createAppointmentFinal(_x1) {
    return _ref4.apply(this, arguments);
  };
}();